import React from 'react'
import { IonCard } from '@ionic/react';

//	S T Y L E

import './com-digitalmenu.scss'

//	S T A T E S   -   P R O P S

import { props___ComDigitalMenuComponent } from './com-digitalmenu.state';

//	C L A S S

export default class ComDigitalMenuComponent extends React.Component<props___ComDigitalMenuComponent, {}> {

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___ComDigitalMenuComponent,
	) {
		super(props);
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonCard className="com-digitalmenu---container" onClick={() => { if (this.props.event___onClick) { this.props.event___onClick(); }}}>
				<img src={this.props.digitalmenu_props['digitalmenu_logo']} />
				<div>
					<h4>{this.props.digitalmenu_props['digitalmenu_name']}</h4>
				</div>
			</IonCard>
		</>;
	}

//#endregion

}